import { render, staticRenderFns } from "./WithdrawValidatorCommissionMessageDetails.vue?vue&type=template&id=89769dce&"
import script from "./WithdrawValidatorCommissionMessageDetails.vue?vue&type=script&lang=js&"
export * from "./WithdrawValidatorCommissionMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports